import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-ui';

import { DateInput } from './DateInput';

export type DateRangeValue = {
  startDate?: string;
  endDate?: string;
};

type Props = {
  disabled?: boolean;
  value?: DateRangeValue;
  limit?: DateRangeValue;
  appendToBody?: boolean;
  forceUserTimeZone?: boolean;
  onChange: (value: DateRangeValue) => void;
};

export function DateRangeInput(props: Props) {
  const { disabled = false, value = {}, limit = {}, onChange, appendToBody = false, forceUserTimeZone } = props;

  function handleOnChangeStartDate(startDate: string | undefined) {
    onChange({ ...value, startDate });
  }

  function handleOnChangeEndDate(endDate: string | undefined) {
    onChange({ ...value, endDate });
  }

  return (
    <Grid container spacing={32}>
      <Grid item>
        <Typography2 component="p" color={disabled ? 'supportText' : 'body'}>
          {_t('Start Date')}
        </Typography2>
        <DateInput
          id="startDate"
          value={value.startDate}
          disabled={disabled}
          onChange={handleOnChangeStartDate}
          selectRange="start"
          otherDate={value.endDate}
          limit={limit}
          appendToBody={appendToBody}
          forceUserTimeZone={forceUserTimeZone}
        />
      </Grid>
      <Grid item>
        <Typography2 component="p" color={disabled ? 'supportText' : 'body'}>
          {_t('End Date')}
        </Typography2>
        <DateInput
          id="endDate"
          value={value.endDate}
          disabled={disabled}
          onChange={handleOnChangeEndDate}
          selectRange="end"
          otherDate={value.startDate}
          limit={limit}
          appendToBody={appendToBody}
          forceUserTimeZone={forceUserTimeZone}
        />
      </Grid>
    </Grid>
  );
}
